import { ValidationRule } from "react-hook-form";
import { VALIDATION } from "../../../constants/validation";

/**
 * The required rule.
 */
export interface RequiredRule {
  /**
   * The required validation rule.
   */
  readonly required?: ValidationRule<boolean>;
}

/**
 * The disabled required rule.
 */
export const DisabledRequiredRule: RequiredRule = {
  required: false,
};

/**
 * Validation rule which indicates whether a field is required.
 * @param required Whether to use the rule or not.
 */
export function required(required: boolean): RequiredRule {
  return required? {
    required: {
      value: true,
      message: VALIDATION.REQUIRED,
    },
  }: DisabledRequiredRule;
}
